import { MihatoMark } from "@/common/components/MihatoMark";
import { Link } from "react-router-dom";

export function LandingFooter() {
  return (
    <footer className="relative z-10 flex flex-wrap items-center justify-between gap-6 bg-brand-dark px-6 py-10 md:px-12">
      <div className="flex items-center gap-3 text-neutral-500">
        <MihatoMark className="h-4 w-4 text-neutral-500" />
        <span className="font-medium text-white text-xs tracking-tight">HATO</span>
        <span className="ml-2 text-xs">© {new Date().getFullYear()}</span>
      </div>
      <div className="flex items-center gap-8 text-neutral-500 text-xs">
        <Link to="/legal/privacy" className="transition-colors hover:text-white">
          Privacidad
        </Link>
        <Link to="/legal/terms" className="transition-colors hover:text-white">
          Términos
        </Link>
      </div>
    </footer>
  );
}
